import React, { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';
import { topicAPI } from '../api/client';
import { useLanguage } from '../context/LanguageContext';
import { ExerciseComponent } from '../components/ExerciseComponent';
import { slugifyLessonTitle } from '../utils/lessonSlug';
import { urlLangToAppLang } from '../utils/routeLanguage';

export const LessonPage = () => {
  const { lang, level, topicSlug } = useParams();
  const navigate = useNavigate();
  const { t, language, setLanguage } = useLanguage();
  const [topic, setTopic] = useState(null);
  const [loading, setLoading] = useState(true);
  const previewPath = `/${lang}/${level}/${topicSlug}`;

  useEffect(() => {
    const nextLanguage = urlLangToAppLang(lang);
    if ((nextLanguage === 'ru' || nextLanguage === 'uk') && nextLanguage !== language) {
      setLanguage(nextLanguage);
    }
  }, [lang, language, setLanguage]);

  useEffect(() => {
    const fetchTopic = async () => {
      try {
        const requestLanguage = urlLangToAppLang(lang);
        const response = await topicAPI.getAllTopics({ language: requestLanguage, includeExercises: false });
        const topics = Array.isArray(response.data) ? response.data : [];
        const match = topics.find((item) => {
          const itemLevel = String(item.level || '').toLowerCase();
          const itemSlug = slugifyLessonTitle(item.germanTitle || item.title || '');
          return itemLevel === String(level || '').toLowerCase() && itemSlug === topicSlug;
        });
        setTopic(match || null);
      } catch (error) {
        console.error('Error fetching topic:', error);
      } finally {
        setLoading(false);
      }
    };

    if (level && topicSlug) {
      fetchTopic();
    }
  }, [level, topicSlug, language, lang]);

  if (loading) {
    return (
      <div className="exercise-page" style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
        <p style={{ color: 'rgba(245,244,240,0.5)', fontSize: 18 }}>{t('loading')}</p>
      </div>
    );
  }

  if (!topic) {
    return (
      <div className="exercise-page" style={{ padding: 32 }}>
        <div style={{ maxWidth: 800, margin: '0 auto' }}>
          <button onClick={() => navigate(previewPath)} className="ticket-back-btn" style={{ marginBottom: 16 }}>
            <ArrowLeft size={16} />
            <span>{t('back')}</span>
          </button>
          <div className="results-tip">
            <p>{t('topicsNotFound')}</p>
          </div>
        </div>
      </div>
    );
  }

  return (
    <ExerciseComponent
      topic={topic}
      onBack={() => navigate(previewPath)}
      onProgressUpdate={() => {}}
    />
  );
};
